import m from 'mithril'
import Ad_collections from '../../models/Ad_collection'
import breadcrumbs from '../components/breadcrumbs'
import gradient_section from '../components/gradient_section'
import popup from '../components/popup'
import quote_bar from '../components/quote_bar'
const image_base = 'https://libraryofshortstories.s3.ap-southeast-2.amazonaws.com/small/'


const Page = {

    oninit: vnode => {

        vnode.state.list = Ad_collections.list
        vnode.state.ad_collection = vnode.state.list.find(ac => ac.code == vnode.attrs.adcollection)
    },

    view: function (vnode) {

        return [

            m(breadcrumbs, {
                links: ['/discover', '/adcollections'],
                title: vnode.state.ad_collection?.title
            }),

            m('.page',
                m(gradient_section,
                    m('.max-700',

                        m('h1.default_h1', vnode.state.ad_collection?.title),
                        m('h2.default_h2', vnode.state.ad_collection?.subtitle),

                        m('.p-10'),
                    )
                ),

                m(quote_bar, { quote: { quote: '“' + vnode.state.ad_collection?.quote + '”' } }),

                m('.p-20',
                    m('.ads',
                        [...Array(vnode.state.ad_collection?.ads)].map((_, i) => [
                            m('.ad_section',
                                m('.ad.cursor_pointer', {
                                    onclick: () => {
                                        vnode.state.selected = [i]
                                    }
                                },

                                    m('img', {
                                        src: image_base + vnode.state.ad_collection?.code + '_' + (i + 1) + '.jpg'
                                    }),
                                    m('.border')
                                ),
                                (vnode.state.ad_collection.ad_sources[i] && vnode.state.ad_collection.ad_sources[i].source) ?
                                    m('a.external_link.ad_source',
                                        {
                                            href: vnode.state.ad_collection.ad_sources[i].link,
                                            target: '_blank'
                                        }, vnode.state.ad_collection.ad_sources[i].source)
                                    : []
                            ),
                        ])

                    )
                ),

                vnode.state.selected ? [m(popup,
                    {
                        class: 'dynamic_popup_2',
                        on_click_outside: () => {
                            delete vnode.state.selected
                        }

                    },
                    m('.ad_scroller',
                        m('.ad.full_size_ad', {

                        },
                            m('img', {
                                src: image_base + vnode.state.ad_collection?.code + '_' + (vnode.state.selected[0] + 1) + '.jpg'
                            }),
                            m('.border')


                        ),

                        m('button.close_popup', {
                            onclick: () => delete vnode.state.selected
                        }, 'Close'
                        )
                    ),

                ),
                ]

                    : [],
            )
        ]
    }
}


export default Page